const API_BASE = import.meta.env.VITE_API_URL ?? 'https://api.memegenes.com';

/**
 * Ask the shared MemeGenes backend whether this visitor's region is blocked.
 *
 * The backend is the single source of truth — the same IP→country (MMDB) lookup
 * and BLOCKED_COUNTRIES list that already 403s every real API call from a
 * blocked region. `/geo/check` only *reports* that verdict so we can show a
 * region screen on load.
 *
 * We fail OPEN: if the check can't complete (network/CORS/backend hiccup), we
 * let the app render. The backend still enforces the block on any real request,
 * so an outage here can never leak access to actual functionality.
 */
export async function checkRegionBlocked(): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE}/geo/check`);
    if (!res.ok) return false;
    const data = (await res.json()) as { blocked?: boolean };
    return data.blocked === true;
  } catch {
    return false;
  }
}
